import React, { useEffect, useState } from 'react'
import { Tab, TabList, TabPanel, Tabs } from 'react-tabs'
import { Link } from 'react-router-dom';
import { ShimmerDiv } from 'shimmer-effects-react';
import CloseSharpIcon from "@mui/icons-material/CloseSharp";
import { customStyles } from '../../../selectStyles';
import { Button, Col, Form, Modal, Row } from 'react-bootstrap';
import toast from 'react-hot-toast';
import { fetchAllCompany } from '../../../redux/actions/getAllCompanyAction';
import { useDispatch, useSelector } from 'react-redux';
import ReactSelect from "react-select";
import DeleteForeverSharpIcon from '@mui/icons-material/DeleteForeverSharp';
import axios from '../../../API/axios';
import error from "../../../assets/images/Not-Found.png";

const ManageComList = () => {
	const sessionId = localStorage.getItem("sessionId");
	const [isLoading, setIsLoading] = useState(false);
	const [companyList, setcmpnyList] = useState([]);
	const [searchcmpnyList, setSearchCmpnyList] = useState([]);

	const [isError, setIsError] = useState(false);
	const [nextBatchLoading, setNextBatchLoading] = useState('')
	const [display, setDisplay] = useState(false);
	const [comId, setComId] = useState("");
	const [comtagId, setComtagId] = useState("");
	const getAllCompanyList = () => {
		setIsLoading(true);
		const data =
		{
			sessionId: sessionId
		};

		axios
			.post(`/Recruiter/GetAssociatedCompanies`, data)
			.then((response) => {
				const res = response.data.responseData;
				console.log("getAllCompanyList", response.data.responseData);
				setcmpnyList(res);
				setIsLoading(false);

			})
			.catch((error) => {
				console.log("error", error)
			});
	};

	useEffect(() => {
		getAllCompanyList(); // Initial fetch on mount
	}, []);

	const [show, setShow] = useState(false);
	const handleShow = () => setShow(true);
	const handleClose = () => {
		setShow(false);
	};

	const AddCompany = async (e) => {
		e.preventDefault();
		setDisplay(true);
		const body = {
			sessionId: sessionId,
			compId: companyListId,
			orgType: orgType

		};
		console.log("body", body);
		if (companyListId === "") {
			toast.error("select Company")
		} else {

			try {
				const res = await axios.post("/Recruiter/AddAssociateCompany", body);
				toast.success(res.data.message);
				handleClose();
				setCompanyListId("")
				getAllCompanyList();
			} catch (error) {
				if (error.response && error.response.status === 404) {
					toast.error(error.response.data.message);
				} else {
					toast.error(error.response?.data?.message);
				}
			}
		}
	};

	const [showdelete, setShowDelete] = useState(false);
	const handleShowDelete = () => setShowDelete(true);
	const handleCloseDelete = () => {
		setShowDelete(false);
	};


	const DeleteCompany = async () => {
		console.log("add class working");
		try {
			const data = {
				sessionId: sessionId,
				compId: comId,
				orgType: comtagId
				// orgType: orgType
			};
			console.log("data====>", data);

			const response = await axios.post("/Recruiter/RemoveAssociatedCompany", data);

			console.log("Delete Company", response);
			toast.success(response.data.message);
			handleCloseDelete();
			getAllCompanyList();
		} catch (error) {
			console.error("Error deleting company:", error);
		}
	};

	const dispatch = useDispatch()
	const [companyListId, setCompanyListId] = useState("");
	const [orgType, setOrgType] = useState("");

	const { getAllcompaniesList, selectedcompaniesId } = useSelector(
		(state) => state.getAllCompany
	);

	useEffect(() => {
		dispatch(fetchAllCompany());
	}, [dispatch]);

	const handleSelectCompany = (selectedOption) => {

		if (selectedOption) {
			setCompanyListId(selectedOption.value);
			setOrgType(selectedOption.tag);
		} else {
			setCompanyListId(null);

		}
	};

	return (
		<>
			<section className={`inner-employer-section  PeopleSearch `}>
				<div className="container">
					<Tabs className="cl8 tf-tab jobcontent">
						<Row>
							<div className="wd-meta-select-jo">
								<div className="wd-findjob-filer">
									<div className="group-select-display">
									</div>
									<button
										className="add-batch-bt manage-button btn-primary"
										onClick={handleShow}
									>
										+  Add Company
									</button>
								</div>
							</div>

						</Row>

						<Row>
							<div className="container ">
								<div className=" content-tab">
									<TabPanel className="inner" style={{
										minHeight: isLoading || nextBatchLoading ? '600px' : 'auto',
										height: 'auto',
									}}>
										<div className="Search-job-group row Search-job-Manage-ComList">
											{isLoading ? (
												<div className="row mt-2">
													<div className="col-md-6">
														<ShimmerDiv mode="light" height={100} width={'100%'} />
													</div>
													<div className="col-md-6">
														<ShimmerDiv mode="light" height={100} width={'100%'} />
													</div>
													<div className="col-md-6 mt-2">
														<ShimmerDiv mode="light" height={100} width={'100%'} />
													</div>
													<div className="col-md-6 mt-2">
														<ShimmerDiv mode="light" height={100} width={'100%'} />
													</div>
													<div className="col-md-6 mt-2">
														<ShimmerDiv mode="light" height={100} width={'100%'} />
													</div>
													<div className="col-md-6 mt-2">
														<ShimmerDiv mode="light" height={100} width={'100%'} />
													</div>
												</div>
											) : isError ? (
												<div className="mt-2 error-image-cont error-cont d-flex justify-content-center">
													{/* <p class=" d-flex justify-content-center">There is no record to display</p> */}
													<img src={error} alt="404 Not Found" width={300} />
												</div>
											) : (
												searchcmpnyList.length === 0 ?
													companyList &&
													companyList?.map((company, index) => {

														console.log("companyList", companyList);

														return (
															<div key={company.id} className="employer-block style-2 col-md-6 comp-shimmer-style p-2">
																<div className="inner-box">
																	<div className="logo-company d-flex ">
																		<img src={company?.tag?.logoImage} alt="User Logo" />
																		<h3 className='ms-2 mb-0'>
																			<Link style={{pointerEvents:"none"}}>{company.name}</Link>
																		</h3>
																	</div>
																	<div className="box-content Associted-Comp-box-content">
																	</div>
																	<div className="button-readmore" style={{ bottom: "0" }}>
																		<button className="btn-employe  Companines-Remove-Btn"
																			onClick={() => {
																				handleShowDelete()
																				setComId(company.id)
																				setComtagId(company?.tag?.orgtype)
																			}
																			}  >
																			Remove
																		</button>
																	</div>
																</div>
															</div>
														);
													}
													) : searchcmpnyList &&
													searchcmpnyList?.map((company, index) => {
														return (
															<div key={company.id} className="employer-block style-2 cl2">
																<div className="inner-box">
																	<div className="logo-company">
																		<img src={company.logoImage} alt="User Logo" />
																	</div>
																	<div className="box-content">
																		<div className="star">{/* Star ratings */}</div>
																		<h3>
																			<Link to={`/Recruiter/${company.id}`}>{company.name}</Link>

																		</h3>
																	</div>
																	<div className="button-readmore">
																		<DeleteForeverSharpIcon
																			onClick={() => {
																				handleShowDelete()
																				setComId(company.id)
																			}
																			} />

																	</div>
																</div>
															</div>
														);
													})
											)}
											{nextBatchLoading && <div className="text-center">
											</div>}
										</div>
									</TabPanel>
								</div>
							</div>

						</Row>

					</Tabs>
				</div>
			</section>


			{/* .......add company modal....  */}

			<Modal show={show} onHide={handleClose} centered size="md">
				<Modal.Header>
					<Modal.Title>Add  Company</Modal.Title>
					<CloseSharpIcon className="pointer" onClick={handleClose} />
				</Modal.Header>
				<Modal.Body className="settings">
					<Row>
						<Col md={12}>
							<Form.Group controlId="Name_Title">
								<Form.Label className="class-type">
									Associated Company
									<span style={{ color: "red" }} className="ms-2">
										*
									</span>

								</Form.Label>
							</Form.Group>
							<ReactSelect
								options={getAllcompaniesList}
								onChange={handleSelectCompany}
								value={
									getAllcompaniesList.find(
										(option) => option.value === companyListId
									) || null
								}
								placeholder="Select Company"
								classNamePrefix="react-select"
								className="form-control"
								styles={customStyles}
								isClearable
							/>
							{display && !companyListId ? (
								<span className="error_msg_lbl">Select Company</span>
							) : null}

						</Col>

					</Row>
					<div className="add-class-submit-button mt-4 d-flex justify-content-center">
						<Button onClick={AddCompany} >Add</Button>
					</div>
				</Modal.Body>
			</Modal>

			{/* .......delete company modal....  */}

			<Modal show={showdelete} onHide={handleCloseDelete} centered size="md">
				<Modal.Header>
					<Modal.Title>Confirm  Delete</Modal.Title>
					<CloseSharpIcon className="pointer" onClick={handleCloseDelete} />
				</Modal.Header>
				<Modal.Body className="settings">
					Are you sure you want to delete this company

					<div className="mt-2  d-flex justify-content-center">
						<Button onClick={DeleteCompany} >Delete</Button>
					</div>
				</Modal.Body>
			</Modal>
		</>

	)
}

export default ManageComList